import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import GoogleIcon from "@mui/icons-material/Google";

/** Tipos de campanha paga (provedor) — alinhado a `ads_workspace_campaign.provider` na API. */
export const PAID_ADS_PROVIDERS = {
  meta: "meta",
  google: "google",
};

export const PAID_ADS_PROVIDER_CARDS = [
  {
    id: PAID_ADS_PROVIDERS.meta,
    key: "meta",
    color: "#0668E1",
    icon: (props) => <CampaignOutlinedIcon {...props} />,
  },
  {
    id: PAID_ADS_PROVIDERS.google,
    key: "google",
    color: "#4285F4",
    icon: (props) => <GoogleIcon {...props} />,
  },
];
